import filterConfig from "./filterConfig";
import tabConfig from "./tabConfig";

export default { filterConfig, tabConfig };
